import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-brand">
          <Link to="/" className="navbar-logo" onClick={closeMenu}>
            <span className="logo-text">Guyana Oil & Gas</span>
          </Link>
        </div>

        <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${isActive('/') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Home
          </Link>
          <Link 
            to="/news" 
            className={`navbar-link ${isActive('/news') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            News
          </Link>
          <Link 
            to="/vacancies" 
            className={`navbar-link ${isActive('/vacancies') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Vacancies
          </Link>
          <Link 
            to="/history" 
            className={`navbar-link ${isActive('/history') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            History
          </Link>
          <Link 
            to="/reserves" 
            className={`navbar-link ${isActive('/reserves') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Reserves
          </Link>
          <Link 
            to="/contractors" 
            className={`navbar-link ${isActive('/contractors') ? 'active' : ''}`}
            onClick={closeMenu}
          >
            Contractors
          </Link>
        </div>

        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isOpen ? 'active' : ''}`}></span>
          <span className={`hamburger ${isOpen ? 'active' : ''}`}></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
